export default "__VITE_ASSET__DZ3g7EvS__"